import {Observable}  from 'rxjs';
import {filter, map} from 'rxjs/operators';

import UiEventType            from '../../../../Ui/Shared/Constants/UiEventType';
import IUiEventsStreamPayload from '../../../../Ui/Shared/Interfaces/IUiEventsStreamPayload';

const subscribeToTimelineTapStream = (uiEvents$: Observable<IUiEventsStreamPayload>): Observable<void> =>
    uiEvents$
        .pipe(
            filter(({type}) => type === UiEventType.TIMELINE_TAP),
            map(() => void 0)
        );

export default subscribeToTimelineTapStream;